import React, { useEffect, useState } from 'react';
import { timeToPixel } from './useKaliaCalendarLayout';

type Props = {
    dayStartMinutes: number;
    dayEndMinutes: number;
    slotDuration: number;
    slotHeight: number;
    timezone: string;
    totalWidth: number;
};

function getNowMinutes(timezone: string): number {
    const now = new Date();
    const formatted = now.toLocaleString('en-US', {
        timeZone: timezone,
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    });
    const [h, m] = formatted.split(':').map(Number);
    return h * 60 + m;
}

function KaliaCalendarNowIndicator({
    dayStartMinutes,
    dayEndMinutes,
    slotDuration,
    slotHeight,
    timezone,
    totalWidth,
}: Props) {
    const [nowMinutes, setNowMinutes] = useState(() => getNowMinutes(timezone));

    useEffect(() => {
        const id = setInterval(() => {
            setNowMinutes(getNowMinutes(timezone));
        }, 60_000);
        return () => clearInterval(id);
    }, [timezone]);

    if (nowMinutes < dayStartMinutes || nowMinutes > dayEndMinutes) {
        return null;
    }

    const BODY_TOP_OFFSET = 9;
    const top = timeToPixel(nowMinutes, dayStartMinutes, slotDuration, slotHeight) + BODY_TOP_OFFSET;

    return (
        <div
            className='absolute left-0 pointer-events-none z-20'
            style={{ top, width: totalWidth }}
        >
            <div className='relative w-full'>
                <div className='absolute left-0 -top-[4px] w-2 h-2 rounded-full bg-red-500' />
                <div className='absolute left-0 w-full border-t border-red-500' />
            </div>
        </div>
    );
}

export default React.memo(KaliaCalendarNowIndicator);
